var map = {
	"./common/grid.json": 54,
	"./common/placeholder.json": 55,
	"./demo/00-splash.json": 56,
	"./demo/01-chalet-backlight.json": 57,
	"./demo/01-chalet-frontlight.json": 58,
	"./demo/01-chalet-ground.json": 59,
	"./demo/01-chalet-text-water-broke.json": 60,
	"./demo/02-forest-backlight.json": 61,
	"./demo/02-forest-frontlight.json": 62,
	"./demo/02-forest-ground.json": 63,
	"./demo/02-forest-text-told-you.json": 64,
	"./demo/02-forest-trigger-text.json": 65,
	"./demo/03-cliff-frontlight.json": 66,
	"./demo/03-cliff-ground.json": 67,
	"./demo/03-cliff-text-problem-baby.json": 68,
	"./demo/03-cliff-trigger-text.json": 69,
	"./demo/04-forest-backlight.json": 70,
	"./demo/04-forest-ground.json": 71,
	"./demo/04-forest-text.json": 72,
	"./demo/04-forest-trigger-text.json": 73,
	"./demo/05-hospital-dear-child.json": 74,
	"./demo/05-hospital-ground.json": 75,
	"./demo/05-hospital-text.json": 76,
	"./demo/05-hospital-trigger-text.json": 77,
	"./demo/character.json": 78,
	"./demo/hitbox-1x1.json": 79,
	"./demo/hitbox-1x4.json": 80,
	"./demo/hitbox-2x1.json": 81,
	"./demo/hitbox-4x1.json": 82,
	"./demo/hitbox-8x1.json": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;